"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToGenderMap = exports.Gender = void 0;
var Gender;
(function (Gender) {
    Gender["FEMALE"] = "FEMALE";
    Gender["MALE"] = "MALE";
})(Gender || (exports.Gender = Gender = {}));
exports.stringToGenderMap = new Map([
    ['FEMALE', Gender.FEMALE],
    ['MALE', Gender.MALE],
]);
//# sourceMappingURL=gender.js.map